var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupo1001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.644,
    height: 119.644,
    viewBox: "0 0 119.644 119.644",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_268",
    x: 0,
    y: 0,
    width: 119.644,
    height: 119.644,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_269",
    x: 10.559,
    y: 10.559,
    width: 98.527,
    height: 98.527,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.835,
    dy: 2.835,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.417,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#5b5b5b",
    floodOpacity: 0.349
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1001",
    "data-name": "Grupo 1001",
    transform: "translate(-13778.653 -9097.088)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13778.65, 9097.09)",
    filter: "url(#Elipse_268)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_268-2",
    "data-name": "Elipse 268",
    cx: 55.57,
    cy: 55.57,
    r: 55.57,
    transform: "translate(1.42 1.42)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 13778.65, 9097.09)",
    filter: "url(#Elipse_269)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_269-2",
    "data-name": "Elipse 269",
    cx: 45.012,
    cy: 45.012,
    r: 45.012,
    transform: "translate(11.98 11.98)",
    fill: "#56af31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1000",
    "data-name": "Grupo 1000",
    transform: "translate(11646.078 1858.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_594",
    "data-name": "Trazado 594",
    d: "M2224.047,7304.218a16.425,16.425,0,0,0-11.09-9.525v-23.448a3.49,3.49,0,0,0-3.485-3.485h-5.4v-.621a3.56,3.56,0,1,0-7.121,0v.621h-17.5v-.621a3.56,3.56,0,1,0-7.121,0v.621h-5.4a3.49,3.49,0,0,0-3.485,3.485v39.912a3.488,3.488,0,0,0,3.485,3.485h26.063a16.418,16.418,0,1,0,31.039-10.424Zm-26.055-35.422v-1.657a2.525,2.525,0,0,1,2.525-2.525h0a2.525,2.525,0,0,1,2.525,2.525v3.314a2.525,2.525,0,0,1-2.525,2.524h0a2.524,2.524,0,0,1-2.525-2.524Zm-24.617,0v-1.657a2.525,2.525,0,0,1,2.525-2.525h0a2.525,2.525,0,0,1,2.525,2.525v3.314a2.524,2.524,0,0,1-2.525,2.524h0a2.525,2.525,0,0,1-2.525-2.524Zm-6.43,44.811a2.45,2.45,0,0,1-2.45-2.45v-39.912a2.449,2.449,0,0,1,2.45-2.449h5.4v1.657a3.56,3.56,0,0,0,7.121,0V7268.8h17.5v1.657a3.56,3.56,0,0,0,7.121,0V7268.8h5.4a2.45,2.45,0,0,1,2.45,2.449v23.222a16.613,16.613,0,0,0-3-.273v-16.8h-41.429v33.213h25.015a16.574,16.574,0,0,0,.272,3Zm25.6-4.034h-24.012v-31.142h39.359v15.795a16.4,16.4,0,0,0-15.347,15.347Zm30.552,7.022a15.378,15.378,0,0,1-29.549-5.986h0a15.371,15.371,0,0,1,15.379-15.38,15.447,15.447,0,0,1,3,.292,15.39,15.39,0,0,1,11.171,21.074Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_595",
    "data-name": "Trazado 595",
    d: "M2217.984,7302.352a1.032,1.032,0,0,0-1.128.225l-10.985,10.984-5.4-5.393a1.035,1.035,0,0,0-1.768.732v5.788a1.036,1.036,0,0,0,.3.733l4.681,4.68a3.085,3.085,0,0,0,4.36,0l10.268-10.269a1.033,1.033,0,0,0,.3-.732v-5.791A1.037,1.037,0,0,0,2217.984,7302.352Zm-.4,6.748-10.269,10.269a2.049,2.049,0,0,1-2.9,0l-4.68-4.681V7308.9l6.128,6.126,11.716-11.717Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_596",
    "data-name": "Trazado 596",
    d: "M2171.473,7288.376h6.059v-6.059h-6.059Zm1.036-5.024h3.987v3.988h-3.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_597",
    "data-name": "Trazado 597",
    d: "M2180.374,7288.376h6.059v-6.059h-6.059Zm1.035-5.024h3.988v3.988h-3.988Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_598",
    "data-name": "Trazado 598",
    d: "M2195.333,7282.317h-6.059v6.059h6.059Zm-1.035,5.023h-3.988v-3.988h3.988Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_599",
    "data-name": "Trazado 599",
    d: "M2204.234,7282.317h-6.059v6.059h6.059Zm-1.036,5.023h-3.988v-3.988h3.988Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_600",
    "data-name": "Trazado 600",
    d: "M2171.473,7297.032h6.059v-6.059h-6.059Zm1.036-5.024h3.987V7296h-3.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_601",
    "data-name": "Trazado 601",
    d: "M2180.374,7297.032h6.059v-6.059h-6.059Zm1.035-5.024h3.988V7296h-3.988Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_602",
    "data-name": "Trazado 602",
    d: "M2195.333,7290.973h-6.059v6.059h6.059ZM2194.3,7296h-3.988v-3.988h3.988Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_603",
    "data-name": "Trazado 603",
    d: "M2171.473,7305.688h6.059v-6.059h-6.059Zm1.036-5.024h3.987v3.988h-3.987Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_604",
    "data-name": "Trazado 604",
    d: "M2180.374,7305.688h6.059v-6.059h-6.059Zm1.035-5.024h3.988v3.988h-3.988Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo1001);
export default __webpack_public_path__ + "static/media/Grupo 1001.63031c70bf552c746cd6a8d3483ae9ab.svg";
export { ForwardRef as ReactComponent };